import { Flex } from "@aircall/tractor";

import { TranscriptionIllustrationLayoutProps } from "./TranscriptionIllustrationLayout.decl";

export function TranscriptionIllustrationLayout({
  children,
  "data-test": dataTest = "transcription-illustration-layout",
}: TranscriptionIllustrationLayoutProps) {
  return (
    <Flex
      flex={1}
      overflow="scroll"
      alignItems="center"
      justifyContent="center"
      data-test={dataTest}
    >
      <Flex flexDirection="column" alignItems="center" gap="s">
        {children}
      </Flex>
    </Flex>
  );
}
